import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import React, { useState, useEffect } from "react";
// Data
import MDButton from "../../components/MDButton";
import OrderEdit from "./edits/OrderEdit";
import buildOrderTable from "./data/orderTableData";
import apis from "../../context/api";

function Order() {
  const [orderUpdate, setOrderUpdate] = useState(false);
  const [id, setId] = useState(null);
  const [quotationData, setQuotationData] = useState({ columns: [], rows: [] });
  const handleCancel = () => {
    setOrderUpdate(false);
  };
  const orderUpdated = () => {
    setOrderUpdate(false);
    loadTableData();
  };
  useEffect(() => {
    loadTableData();
  }, []);
  const editCombo = (id) => {
    setId(id);
    setOrderUpdate(true);
  };

  const loadTableData = async () => {
    try {
      apis
        .getOrders()
        .then((data) => {
          setQuotationData(buildOrderTable(data, (id) => editCombo(id)));
        })
        .catch((err) => {
          throw new Error("Can not fetch orders");
        });
    } catch (err) {
      console.error("Data loading error:", err);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {orderUpdate && <OrderEdit onSuccess={orderUpdated} id={id} onCancel={handleCancel} />}
      {!orderUpdate && (
        <MDBox pt={6} pb={6}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Orders Table
                  </MDTypography>
                </MDBox>
                <Grid container justifyContent="flex-end" pr={2} pt={2}>
                  <Grid item>
                    <MDButton variant="gradient" color="info" onClick={() => setOrderUpdate(true)}>
                      Update
                    </MDButton>
                  </Grid>
                </Grid>
                <MDBox pt={3}>
                  <DataTable
                    table={{ columns: quotationData.columns, rows: quotationData.rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default Order;
